import { Navigate } from "react-router-dom";
import LoginLanding from "../pages/LoginLanding/LoginLanding";
import { isLoginMethodEnabled, loginConfig, loginMethodPath, SELF_SIGNUP_ENABLED } from "./config";

/**
 * Route guards driven by auth/config.js's `loginConfig` (same mechanism as lms-kriha-frontend).
 *
 * LoginEntry is what "/" renders:
 *  - Exactly one method enabled: skip the chooser and land straight on that method's page.
 *  - Otherwise: render the LoginLanding chooser.
 */
export function LoginEntry() {
  if (loginConfig.methods.length === 1) {
    return <Navigate to={loginMethodPath[loginConfig.methods[0]]} replace />;
  }
  return <LoginLanding />;
}

export function LoginMethodRoute({ method, children }) {
  return isLoginMethodEnabled(method) ? children : <Navigate to="/" replace />;
}

export function SignupRoute({ children }) {
  return loginConfig.selfSignup && SELF_SIGNUP_ENABLED ? children : <Navigate to="/" replace />;
}
